
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/account/charter",
      function () {
        return require("private-next-pages/account/charter/index.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/account/charter"])
      });
    }
  